import { useEffect, useRef } from 'react'

// Based on code by José Manuel Lucas (MIT License)
// https://github.com/jmlweb/isMounted
export const useIsMounted = () => {
    const isMounted = useRef(false)
    useEffect(() => {
        isMounted.current = true
        return () => (isMounted.current = false)
    }, [])
    return isMounted
}
